var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-row',[_c('div',{staticClass:"col-md-12"},[_c('petty-cash',{attrs:{"header":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }